import { usePunditUserContext } from "@circle-react/contexts";

export const useIsModifyScheduleEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.modify_schedule_enabled);
};
